import { render } from "./header.vue?vue&type=template&id=249b5612&ts=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"

import "./header.vue?vue&type=style&index=0&id=249b5612&lang=scss"

import exportComponent from "/Users/cuixg/Desktop/web/magic/admin/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__